import { persist, StateStorage } from 'zustand/middleware';
import type { StateCreator } from 'zustand';

import { createStore } from './utils';

interface NavigationStackState {
  ancestor: string;
  stack: string[];
  prevAncestor: string | null;
  push: (path: string) => void;
  pop: () => string | null;
  peek: () => string | null;
  reset: () => void;
  includes:(path:string) => boolean;
  setAncestor: (ancestor:string) => void
}

const navigationStackStateCreator: StateCreator<NavigationStackState> = persist(
  (set: any, get: any) => ({
    ancestor: '',
    prevAncestor: null,
    stack: [],

    push: (path: string) => {
      if (!path) return;
      const stack = get().stack;
      if (stack[stack.length - 1] !== path) {
        set({ stack: [...stack, path].slice(-50) });
      }
    },

    pop: () => {
      const stack = get().stack;
      if (stack.length <= 1) {
        set({ stack: [] });
        return null;
      }
      const newStack = stack.slice(0, -1);
      set({ stack: newStack });
      return newStack[newStack.length - 1] || null;
    },

    peek: () => get().stack[get().stack.length - 1] || null,

    reset: () => set({ stack: [] }),

    setAncestor: (ancestor: string) => {
      const current = get().ancestor;
      if (current !== ancestor) {
        set({
          prevAncestor: current || null,
          ancestor,
          stack: [],
        });
      }
    },
    includes: (path: string) => {
      return get().stack.includes(path);
    },
  }),
  {
    name: 'nav-stack',
    getStorage: (): StateStorage => sessionStorage,
  }
) as unknown as StateCreator<NavigationStackState>;


export const useNavigationStack = createStore<NavigationStackState>(
  'NavigationStackStore',
  navigationStackStateCreator
);
